export const getColorCode = (colorArray?: { codename: string }[]) =>
  colorArray?.[0]?.codename || '';

export const getColors = (...colorArrays: ({ codename: string }[] | undefined)[]) =>
  colorArrays.map(getColorCode);
